export const WISHLIST_LOCAL_STORAGE_KEY = 'wishList_room_id';

// Carries the room to save through a magic-link login, which lands in whichever tab opens the email.
export const WISHLIST_ROOM_ID_QUERY_PARAM = 'wishlistRoomId';
